// @flow
import './index.less';

import classNames from 'classnames';
import React from 'react';

import PaymentManager from '_components/PaymentManager';
import {useCheckout, useCheckoutState} from '_contexts/checkout';

type Props = {
  active?: boolean,
};

const PaymentMethodSelector = ({active}: Props): React$Node => {
  const {paymentMethod} = useCheckoutState();
  const {setPaymentMethod} = useCheckout();

  return (
    <div className={classNames('payment-method-selector', {'payment-method-selector-active': active})}>
      <PaymentManager
        active={active}
        selectedPaymentMethod={paymentMethod}
        onSelectPaymentMethod={setPaymentMethod}
        selectable={active}
        showAddFormOnEmptyPaymentMethods
      />
    </div>
  );
};

export default PaymentMethodSelector;
